export default __webpack_public_path__ + "static/media/feat_donvkim.89f132b5.jpg";